import { useRef as u, useLayoutEffect as s, useMemo as n } from "../external/preact/hooks/dist/hooks.module.js";
import { createReflexContainer as o } from "../primitives/reactive/reflex/main.js";
const c = (r, t) => {
  const e = u(o());
  return s(() => e.current.release, []), n(() => (e.current.update(r, t), e.current.reflex), [r, t]);
};
export {
  c as default
};
